import styled from "styled-components";
import { toAbsoluteUrl } from "../../../utils/assetHelper";

export const IntellectualHeader = styled.div`
margin-top: 20px;
h1{
    font-size: 48px;
    font-weight: 800;
    margin-bottom: 16px;
    text-align: center;
    color: #fff;

    @media screen and (max-width: 1100px) {
        font-size: 36px;
    }

    span{
        color: var(--primary-color);
    }
}
`

export const Wrapper = styled.div`
.bio-container{
background: url(${toAbsoluteUrl('/media/intellectual/header1.png')}) no-repeat;
background-size: cover;
background-position: bottom center;

@media screen and (max-width:1100px) {
background-position: left bottom;
}
}

`

export const IntellectualContent = styled.div`
.intellectual-wrapper {
width: 98vw;
margin: 0 auto;
display: grid;
gap: 16px;
padding: 60px 96px;
border-radius: 20px;
background: linear-gradient(270deg, rgba(63, 27, 208, 0.05) 4.47%, rgba(215, 76, 16, 0.05) 54.56%);
margin-bottom: 32px;
margin-top: 32px;

@media screen and (max-width:1100px) {
padding: 60px 1.2rem;

h2 {
font-size: 36px !important;
}

h3 {
font-size: 26px !important;
}

}

h2 {
font-size: 42px;
font-style: normal;
font-weight: 800;
line-height: 60px;
text-align: center;
}

h3 {
margin-top: 16px;
margin-bottom: 16px;
font-size: 32px;
font-style: normal;
font-weight: 600;
text-align: left;
color: var(--dark-grey);
text-decoration: underline;
}


h5{
font-size: 20px;
font-style: normal;
font-weight: 600;
line-height: 24px;
text-align: left;
color: var(--primary-color);
}

p{
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: 28px;
text-align: left;

span{
    color: var(--primary-color);
    font-weight: 700;
}
}

ul {
display: grid;
gap: 5px;
padding-left: 25px;
margin: 5px 0;
list-style: disc;
font-size: 20px;
font-weight: 400;
}
}`